export default __webpack_public_path__ + "static/media/united-kingdom.7be3d5a2.png";